export default {
  data() {
    return {
      columns: [
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          fixed: 'left',
          customRender: (text, record, index) =>
            (this.pageData.current - 1) * this.pageData.pageSize + (index + 1),
        },
        {
          title: '附件名称',
          dataIndex: 'name',
        },
        {
          title: '文件编号',
          dataIndex: 'id',
        },
        {
          title: '备注',
          dataIndex: 'remark',
        },
        {
          title: '创建人员',
          dataIndex: 'creator',
        },
        {
          title: '创建日期',
          dataIndex: 'createTime',
        },
        {
          title: '编辑日期',
          dataIndex: 'updateTime',
        },
        {
          title: '操作',
          fixed: 'right',
          width: 160,
          dataIndex: 'action',
          slotName: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      TYPE_1: 1,
      TYPE_2: 2,
      TYPE_3: 3,
      TYPE_4: 4,
      TYPE_5: 5,
      TYPE_6: 6,
      TYPE_NAME_OBJ: {
        1: '保险',
        2: '担保-保证书',
        3: '担保-房产抵押',
        4: '担保-银行保函',
        5: '担保-股权置押',
        6: '担保-库存置押',
      },
    }
  },
}
